import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tyreQueryKeys } from '../api/queryKeys';

const useTyreMutation = (mutationFn, { invalidate = true } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => (invalidate
      ? queryClient.invalidateQueries({ queryKey: tyreQueryKeys.all })
      : undefined),
  });
};

export default useTyreMutation;
